import Srcset from "@/components/common/Srcset";
import { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "./CharitySelector.module.scss";
import { saveUserCharityLocalStorage, updateUserCause } from "@/helpers/charityHelper";
import { setUserCause } from "@/redux/actions/generalAction";
import TickMarkComponentLarge from "@/components/Logos/TickMark_large";
import WelcomeJourneyFooter from "../WelcomeJourneyFooter";
import { WelcomeJourneyState, isVisited, welcomeStep } from "@/redux/actions/pwaAction";

export default function CharitySelector(props) {
  const cause_list = useSelector((state) => state.general.cause_list);
  const user_cause = useSelector((state) => state.general.user_cause);
  const is_userLoggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const dispatch = useDispatch();
  const welcomeJourneyStates = useSelector((state) => state.pwa.welcome_journey);
  // creating state to keep track of selected charity
  const [selectedCharity, setSelectedCharity] = useState("")
  const [scrollOnLoad, setScrollOnLoad] = useState(true);

  function groupByCategory(data) {
      return data?.reduce((result, item) => {
        const category = item.category;
    
        if (!result[category]) {
          result[category] = [];
        }
      if(item?.short_code == user_cause) {
        setSelectedCategory(category);
      }
        result[category].push(item);
        return result;
      }, {});
  }

  //sort the charities with first static values and then dynamic based on alphabetic order
  function charitySort(causeList, staticValues) {
    const staticPart = causeList?.filter(obj => staticValues?.includes(obj?.short_code))?.sort((a, b) => staticValues?.indexOf(a.short_code) - staticValues?.indexOf(b.short_code));
    const dynamicPart = causeList?.filter(obj => !staticValues?.includes(obj?.short_code))?.sort((a, b) => a.name.localeCompare(b.name));
    return staticPart?.concat(dynamicPart);
  }

  //sort the charities based on group
  async function charityGroupSort(charityGroup, keyValues) {
    const sortedObject = {};
    await keyValues.forEach(key => {
        if (charityGroup?.hasOwnProperty(key)) {
            sortedObject[key] = charityGroup[key];
        }
    });
    return sortedObject;
  }

  const handleCauseSelect = (selCause) => {
    // setting the value to the selected charity
    setSelectedCharity(selCause.short_code);
    setScrollOnLoad(true)
  }

  const [charityGroup, setCharityGroup] = useState([]);  
  const causeRef = useRef(null);
  const [finalSortedCharity, setFinalSortedCharity] = useState([]);

  const setCharArray = async(el) => {
    // Define the static chairty values
    if(!cause_list.length) {
      return true;
    }
    const charityStaticValues = ["care","stc","malaika","rewild","edn","eden","stjude","cancercartel","facefwd"];
    const charitySortedArray = await charitySort(cause_list, charityStaticValues);
    const charityGroupArray = await groupByCategory(charitySortedArray);
    setCharityGroup(charityGroupArray);
    setFinalCharArray(charityGroupArray);
    // define charity group order
  }

  const setFinalCharArray = async(charityGroupArray) => {
    const charityGroupStaticValues = ['Gender equality', 'Nature', 'Health and wellness'];
    const finalCharitypArray = await charityGroupSort(charityGroupArray, charityGroupStaticValues);
    
    setFinalSortedCharity(finalCharitypArray);
  }

  const [categoryCharityPair, setCategoryCharityPair] = useState({});
  useEffect(() => {
    if(finalSortedCharity && (selectedCharity || user_cause)) {
      finalSortedCharity && Object.keys(finalSortedCharity)?.map((element, index) => {
        finalSortedCharity[element].filter((charity) => {
          if (!selectedCharity ? charity.slug == user_cause : charity.slug == selectedCharity){
            setCategoryCharityPair({ category: element, charity: charity.name });
          }
        })
      });
    }
  },[selectedCharity,props.step,user_cause,finalSortedCharity])

  useEffect(() => {
    setCharArray()
  },[props.step])

  useEffect(() => {
    if(charityGroup && !finalSortedCharity.length) {
      setFinalCharArray(charityGroup);
    }
  },[charityGroup,props.step])

  //scroll selected charity into view when it is not in viewport.
  useEffect(() => {
    if (props.step == 4 && scrollOnLoad) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          var index = causeRef?.current?.closest("section")?.getAttribute('data-sectionlevel')
          // let doesOverlap = entry.boundingClientRect.y <= causeRef?.current?.bottom;
          if ((!entry.isIntersecting || index > 1) && scrollOnLoad) {
            if (index > 1) {
              causeRef?.current?.scrollIntoView({ behavior: "smooth" });
            } else if (index < 1) {
              if (!isElementInViewportVertical(causeRef?.current)) {
                causeRef?.current?.scrollIntoView(false, { behavior: "smooth" });
              } else {
                causeRef?.current?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
              }
            } else {
              if (!isElementInViewportHorizontal(causeRef?.current)) {
                causeRef?.current?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
              }
            }
            setScrollOnLoad(false)
          }
        }, {
        // root:document.body,
        threshold: 1
      });
      if (causeRef?.current) {
        observer.observe(causeRef.current);

      }
      return () => {
        if (causeRef?.current) {
          observer.unobserve(causeRef?.current);
        }
      }
    }
  }, [causeRef, props.step, scrollOnLoad, user_cause]);
  
    // Function to check if an element is in the viewport horizontally
    const isElementInViewportHorizontal = (el) => {
      const rect = el?.getBoundingClientRect();
      return (
        rect?.left >= 0 &&
        rect?.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    };
  
  // Function to check if an element is in the viewport vertically
  const isElementInViewportVertical = (el) => {
    var rect = el?.getBoundingClientRect();
    return (
      rect?.top >= 0 && rect?.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

// useEffect(() => {
//   if(selectedCategory && props.step==4) {
//     var index = Object.keys(charityGroup).indexOf(selectedCategory);
//     setSelectedRow(index);
//   }
// }, [charityGroup,selectedCategory]);
  
  const skipClickHandler = (e) => {
    e.preventDefault();
    document.querySelector("#__next").classList.add("pwa-transition");
    setTimeout(() => {
      document.querySelector("#__next").classList.remove("pwa-transition");
    }, 2000);
    dispatch(WelcomeJourneyState({ ...welcomeJourneyStates, addWCOverlay: false, currentStepNo:6, isSkipped: true }));
}
    
const nextClickHandler = (e) => { 
  e.preventDefault();
  // when user clicks on next button then dispatch action should trigger
  // if they click on skip button then charity shouldnt update
    let request = {}
    if (cause_list && cause_list.length > 0 && selectedCharity != user_cause) {
      if (is_userLoggedIn) {
        const cause = selectedCharity ? selectedCharity : user_cause;
        request.cause = cause;
        console.log('updateUserCause CharitySelector=====')
        updateUserCause(request);
        dispatch(setUserCause(cause));
      }
    }
    document.querySelector("#__next").classList.add("pwa-transition");
    setTimeout(() => {
      document.querySelector("#__next").classList.remove("pwa-transition");
    }, 2000);
    dispatch(WelcomeJourneyState({ ...welcomeJourneyStates, addWCOverlay: false, currentStepNo:6 }));
}
    

  return (
    <>
      <div className={styles.inner_wrapper}>
        <div className={`${styles.charity_selector}`}>
          {finalSortedCharity && Object.keys(finalSortedCharity)?.map((element, index) => {
            return (
              finalSortedCharity[element][0].category !== undefined && (
                <section data-sectionlevel={index}>
                  <div className={`${styles.pillar_title} small`}>
                    <div className={styles.category}>
                        {finalSortedCharity[element][0].category == "Gender equality" ? "Education" :
                        charityGroup[element][0].category == "Health and wellness" ? "Health & wellness" :
                        charityGroup[element][0].category}
                    </div>
                    <div className={`${styles.charity_name} xx-small-xs`}>
                      {categoryCharityPair.category == finalSortedCharity[element][0].category ?
                      categoryCharityPair.charity : ""}
                    </div>
                  </div>
                  <ul className={styles.clist}>
                    {finalSortedCharity[element]
                      .filter((ele) => ele.active == 1 && ele.charity_logo)
                      .map((ele, i) => {
                        return (
                          <li
                            className={`${
                              (!selectedCharity ? ele.short_code == user_cause : ele.short_code == selectedCharity)
                                ? styles.selected_charity
                                : ""
                              }`}
                            key={i}
                          >
                            <div
                              className={`${styles.charity_img}`}
                              onClick={() => handleCauseSelect(ele)}
                            >
                              <img
                                src={
                                  ele.charity_logo ? ele.charity_logo : `https://cdn.builder.io/api/v1/image/assets%2F1136b0d62d5c4bbdaf0e94e5b76086d8%2F27fbcba930a548c4adaa008ea05f75c6?width=638`
                                }
                              />
                              {/* handling conditions with and without selected charity */}
                              {(!selectedCharity ? ele.short_code == user_cause: ele.short_code == selectedCharity) && (
                                <span ref={causeRef} className={`${styles.selected_tick}`}>
                                  <TickMarkComponentLarge
                                    stroke="#ffffff"
                                    fill="#fff"
                                    width="36"
                                    height="26"
                                  />
                                </span>
                              )}

                            </div>
                          </li>
                        );
                      })}
                  </ul>
                  {index!=2 && <div className={styles.separator}></div>}
                </section>
              )
            );
          })}
        </div>
      </div>
      <WelcomeJourneyFooter
        heading="Choose your charity"
        description="20% of the net proceeds from every purchase supports causes at the forefront of gender equality."
        btn1_text="Start shopping"
        btn2_text="Skip"
        btn2ClickHandler={(e) => {
          skipClickHandler(e);
        }}
        btn1ClickHandler={(e) => {
          nextClickHandler(e);
        }}
        ga4tag1="App: Welcome > Cause partner > Start shopping"
        ga4tag2="App: Welcome > Cause partner > Skip"
      />
    </>
  );

}
